import { render, staticRenderFns } from "./fx-calculator.vue?vue&type=template&id=209a32c3&"
import script from "./fx-calculator.vue?vue&type=script&lang=js&"
export * from "./fx-calculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports